import isString from 'lodash/isString';

export const transformJSONStringToObject = (value: string | unknown) => {
	try {
		return isString(value) ? JSON.parse(value) : value;
	} catch {
		return value;
	}
};
